import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'
import * as actions from 'redux/actions/domainTags.actions'
import { loadDomainTags, loadKeywords } from 'redux/actions/domainsData.actions'
import NotificationToast from '_base/Notification'

function* addDomainTagSaga(params) {
  try {
    const { domainId, payload } = params.payload.data
    const data = yield call(agent.Tags.create, domainId, payload)

    yield put(loadDomainTags(domainId, false))

    yield put(actions.addDomainTagSuccess(domainId, data))
  } catch (error) {
    if (error.response.status === 422) {
      NotificationToast('error', `${error.response.body.errors[0].detail}`)
    }
  }
}

function* removeDomainTagSaga(params) {
  try {
    const { domainId, tagId } = params.payload.data
    const data = yield call(agent.Tags.del, domainId, tagId)

    yield put(loadDomainTags(domainId, false))

    yield put(actions.removeDomainTagSuccess(domainId, data))
  } catch (error) {
    if (error.response.status === 422) {
      NotificationToast('error', `${error.response.body.errors[0].detail}`)
    }
  }
}

function* updateDomainTagSaga(params) {
  try {
    const { domainId, tagId, payload, filters } = params.payload.data

    const data = yield call(agent.Tags.update, domainId, tagId, payload.payload)

    //There is no need to refresh all keywords when only name changed
    if (typeof payload.payload.tag.colour !== 'undefined') {
      yield put(loadKeywords(domainId, filters))
    }

    yield put(loadDomainTags(domainId, false))

    yield put(actions.updateDomainTagSuccess(domainId, data))
  } catch (error) {
    if (error.response.status === 422) {
      NotificationToast('error', `${error.response.body.errors[0].detail}`)
      yield put()
    }
  }
}

function* addTagsToKeywordsSaga(params) {
  try {
    const { domainId, payload, filters, refreshKeywords } = params.payload.data

    const data = yield call(agent.Tags.addTagsToKeywords, domainId, payload)

    if (refreshKeywords) {
      yield put(loadDomainTags(domainId, false))
      yield put(loadKeywords(domainId, filters))
    }
    yield put(actions.addTagsToKeywordsSuccess(domainId, data))
  } catch (error) {
    if (error.response.status === 422) {
      NotificationToast('error', `${error.response.body.errors[0].detail}`)
    }
  }
}

function* deleteTagsFromKeywordsSaga(params) {
  try {
    const { domainId, payload, filters, refreshKeywords } = params.payload.data

    const data = yield call(agent.Tags.deleteTagsFromKeywords, domainId, payload)

    if (refreshKeywords) {
      yield put(loadDomainTags(domainId, false))
      yield put(loadKeywords(domainId, filters))
    }
    yield put(actions.deleteTagsFromKeywordsSuccess(domainId, data))
  } catch (error) {
    if (error.response.status === 422) {
      NotificationToast('error', `${error.response.body.errors[0].detail}`)
    }
  }
}

export default function* domainTagsSagas() {
  yield all([
    takeLatest(actions.addDomainTag.type, addDomainTagSaga),
    takeLatest(actions.removeDomainTag.type, removeDomainTagSaga),
    takeLatest(actions.updateDomainTag.type, updateDomainTagSaga),
    takeLatest(actions.addTagsToKeywords.type, addTagsToKeywordsSaga),
    takeLatest(actions.deleteTagsFromKeywords.type, deleteTagsFromKeywordsSaga)
  ])
}
